import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';

export const aideSousMenuItem = new SousMenuItemAggregate(
  'Aide en ligne',
  'https://espaceclient.eparcours.axess.fr/aide-en-ligne/',
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.SupportAxess)]),
  'icon-idea',
).defineAsOutsideURL();

export const tutoVideoSousMenuItem = new SousMenuItemAggregate(
  'Tuto / Vidéos',
  'https://espaceclient.eparcours.axess.fr/tutos/',
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.SupportAxess)]),
  'icon-videocam',
).defineAsOutsideURL();

export const actualitesSousMenuItem = new SousMenuItemAggregate(
  'Actualités',
  'https://espaceclient.eparcours.axess.fr/informations/',
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.SupportAxess)]),
  'icon-bolt',
).defineAsOutsideURL();

export const versionSousMenuItem = new SousMenuItemAggregate(
  'Versions',
  'https://espaceclient.eparcours.axess.fr/versions/',
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.SupportAxess)]),
  'icon-calendar2',
).defineAsOutsideURL();
